import CategoryCommandDropdown from "@ready/CategoryCommandDropdown";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ToggleWrapper from "../../../ToggleWrapper";
import { ProductSchemeTyping } from "../../../types";
import CategoryCreationModal from "../modals/category/CategoryCreationModal";

export default function CategoryDropdown() {
    const { t } = useTranslation("", { keyPrefix: "products" });

    const [isCreationModalOpen, setIsCreationModalOpen] = useState<boolean>(false);

    const { control, setValue } = useFormContext<ProductSchemeTyping>();

    return (
        <>
            <ToggleWrapper label={t("general.fields.category.label")} fieldKey="category">
                <Controller
                    name="general.category"
                    control={control}
                    render={({ field, fieldState }) => (
                        <CategoryCommandDropdown
                            onSelect={(e) => {
                                field.onChange(e.current?.item);
                            }}
                            value={field.value?.id}
                            multiple={false}
                            module="product"
                            error={fieldState.error}
                        />
                    )}
                />
            </ToggleWrapper>

            <CategoryCreationModal
                isOpen={isCreationModalOpen}
                onClose={() => setIsCreationModalOpen(false)}
                onCreation={(category) => {
                    setValue("general.category", category);
                }}
            />
        </>
    );
}
